import { KeyValueStorageInterface } from 'aws-amplify/utils';

export class AmplifyStorage implements KeyValueStorageInterface {
  private static readonly PREFIX = 'AMP:';

  constructor(
    private sessionTokenStorage: Storage = window.sessionStorage,
    private deviceTokenStorage: Storage = window.localStorage,
  ) {}

  private getStorageType(key: string): Storage {
    return /\.(?:deviceGroupKey|deviceKey|randomPasswordKey)$/.test(key) ? this.deviceTokenStorage : this.sessionTokenStorage;
  }

  public async setItem(key: string, value: string): Promise<void> {
    this.getStorageType(key).setItem(`${AmplifyStorage.PREFIX}${key}`, value);
  }

  public async getItem(key: string): Promise<string | null> {
    return this.getStorageType(key).getItem(`${AmplifyStorage.PREFIX}${key}`);
  }

  public async removeItem(key: string): Promise<void> {
    this.getStorageType(key).removeItem(`${AmplifyStorage.PREFIX}${key}`);
  }

  public async clear(): Promise<void> {
    this.clearStorage(this.sessionTokenStorage);
    this.clearStorage(this.deviceTokenStorage);
  }

  private clearStorage(storage: Storage): void {
    const keys: string[] = [];

    for (let i = 0; i < storage.length; i++) {
      const k = storage.key(i);
      if (k?.startsWith(AmplifyStorage.PREFIX)) {
        keys.push(k);
      }
    }

    keys.forEach(k => storage.removeItem(k));
  }
}
